// extracted by mini-css-extract-plugin
export default {"form":"NewPasswordForm_form__8aVaB","actions":"NewPasswordForm_actions__vP1nC","cancel":"NewPasswordForm_cancel__6GK9l"};